<ng-order-history-header-container
  [customDateRange]="customDateRange"
  (selectedOrderFill)="emitOrderFill($event)">
</ng-order-history-header-container>

<ng-container *ngIf="!(loadingFilters || loading); else mask">
  <div class="container-fluid flex-grow-1">
    <div class="row d-flex align-items-center">
      <div class="col col-xl-4 col-lg-12 py-2 d-flex flex-column align-items-center">
        <div class="d-flex">
          <div class="record d-flex flex-column pt-2 px-3"
               (mouseover)="updateConfig(orderFillTypes.NOT_ACCEPTED)" (mouseout)="updateConfig()">
            <div class="mb-2 font-weight-bold">REQUESTED</div>
            <h1 class="mt-auto">{{ requested | decimalFormat }}</h1>
          </div>
          <div class="record d-flex flex-column pt-2 px-3"
               (mouseover)="updateConfig(orderFillTypes.ACCEPTED_NOT_FILLED)" (mouseout)="updateConfig()">
            <div class="mb-2 font-weight-bold">ACCEPTED</div>
            <h1 class="mt-auto">{{ accepted | decimalFormat }}</h1>
          </div>
          <div class="record d-flex flex-column pt-2 px-3"
               (mouseover)="updateConfig(orderFillTypes.FILLED)" (mouseout)="updateConfig()">
            <div class="mb-2 font-weight-bold">FILLED</div>
            <h1 class="mt-auto">{{ filled | decimalFormat }}</h1>
          </div>
        </div>
      </div>
      <div class="col-xl-8 col-lg-12 pb-xl-0 pb-3 d-flex justify-content-center justify-content-xl-start">
        <ng-container *ngTemplateOutlet="viewType === orderViewTypeOption.DAILY ? dailyLegends : weeklyLegends"></ng-container>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-4 mb-lg-0 mb-4">
        <mat-card>
          <mat-card-header class="text-center">
            <mat-card-title class="mt-2">
              <span class="font-weight-bold">{{ pieChartTitle.split(' ')[0] }}</span>
              <span class="pl-1 light">{{ pieChartTitle.split(' ')[1] }}</span>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="mb-5" echarts [options]="chartConfig" [merge]="updatedConfig" style="height: 175px;"></div>
            <div class="border-bottom"></div>
            <div class="mt-5 row align-items-center">
              <div class="col-6 d-flex flex-column align-items-center">
                <div class="title">Order Fill</div>
                <div echarts [options]="orderFillConfig" class="flex-fill w-100" style="height: 120px;"></div>
                <div class="text-dark text-center">
                  <span class="font-weight-bold"> {{ filled | decimalFormat }} </span> <span class="text-muted">Filled vs.</span>
                  <span class="font-weight-bold"> {{ requested | decimalFormat }} </span> <span class="text-muted">Requested</span>
                </div>
              </div>
              <div class="col-6 d-flex flex-column align-items-center">
                <div class="title">Accepted Fill</div>
                <div echarts [options]="acceptedFillConfig" class="flex-fill w-100" style="height: 120px;"></div>
                <div class="text-dark text-center">
                  <span class="font-weight-bold"> {{ filled | decimalFormat }} </span> <span class="text-muted">Filled vs.</span>
                  <span class="font-weight-bold"> {{ accepted | decimalFormat }} </span> <span class="text-muted">Accepted</span>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-md-12 col-lg-8 mb-lg-0 mb-4">
        <ng-daily-chart
          *ngIf="viewType === orderViewTypeOption.DAILY"
          [metrics]="metrics"
          [dateInterval]="dateInterval"
          (returnNavigation)="returnNavigation()">
        </ng-daily-chart>
        <ng-weekly-chart
          *ngIf="viewType !== orderViewTypeOption.DAILY"
          [title]="barChartTitle"
          [metrics]="metrics"
          [dateInterval]="dateInterval"
          [doofFeature]="doofFeature"
          (changeViewType)="customDateRange = $event">
        </ng-weekly-chart>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #mask>
  <div class="w-100 d-flex align-items-end">
    <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
  </div>
</ng-template>

<ng-template #dailyLegends>
  <div class="d-flex flex-wrap align-items-end">
    <div class="d-flex flex-column">
      <div class="d-flex mx-3 my-2 align-items-center">
        <div class="rounded-circle mr-3 green"></div>
        <span>Filled <span class="fill-type">(within Request)</span></span>
      </div>

      <div class="d-flex mx-3 my-2 align-items-center">
        <div class="rounded-circle mr-3 light-green"></div>
        <span>Filled <span class="fill-type">(outside Request)</span></span>
      </div>
    </div>
    <div class="d-flex flex-column">
      <div class="d-flex mx-3 my-2 align-items-center">
        <div class="rounded-circle mr-3 yellow"></div>
        <span>Accepted <span class="fill-type">(Not Filled)</span></span>
      </div>
      <div class="d-flex mx-3 my-2 align-items-center">
        <div class="rounded-circle mr-3 pink"></div>
        <span>Not Accepted</span>
      </div>
    </div>
    <div class="d-flex flex-column">
      <div class="d-flex mx-3 my-2 align-item-center">
        <div class="rounded-circle mr-3 light-blue"></div>
        <span>Released Loaded</span>
      </div>
      <div class="d-flex mx-3 my-2 align-items-center">
        <div class="line mx-3"></div>
        <span>Requested</span>
        <div class="line mx-3"></div>
      </div>
    </div>
    <div class="d-flex flex-column">
      <div class="d-flex mx-3 my-2 align-item-center">
        <div class="rounded-circle mr-3 blue"></div>
        <span>On Premise</span>
      </div>
      <div class="d-flex mx-3 my-2 align-items-center">
        <div class="rounded-circle mr-3 lighter-blue"></div>
        <span>On Premise <span class="fill-type">(rejected)</span></span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #weeklyLegends>
  <div class="d-flex flex-wrap align-items-end">
    <div class="d-flex flex-column">
      <div class="d-flex mx-3 my-2 align-items-center">
        <div class="rounded-circle mr-3 green"></div>
        <span>Filled <span class="fill-type">(within Request)</span></span>
      </div>
      <div class="d-flex mx-3 my-2 align-items-center">
        <div class="rounded-circle mr-3 light-green"></div>
        <span>Filled <span class="fill-type">(outside Request)</span></span>
      </div>
    </div>
    <div class="d-flex flex-column">
      <div class="d-flex mx-3 my-2 align-items-center">
        <div class="rounded-circle mr-3 yellow"></div>
        <span>Accepted <span class="fill-type">(Not Filled)</span></span>
      </div>
      <div class="d-flex mx-3 my-2 align-items-center">
        <div class="rounded-circle mr-3 pink"></div>
        <span>Not Accepted</span>
      </div>
    </div>
    <div class="d-flex mx-3 my-2 align-items-center">
      <div class="line mx-3"></div>
      <span>Requested</span>
      <div class="line mx-3"></div>
    </div>
  </div>
</ng-template>
